export class UCuencaErrorHandler{

    // tslint:disable-next-line:no-trailing-whitespace
    public handleError(error: any): Promise<any> {    
      if(error) {
        if ( error.status == 0 ){
          return Promise.reject('Servicio no disponible por el momento.');
        } else {
          // tslint:disable-next-line:one-line
          if (error.message){
            // tslint:disable-next-line:prefer-const
            let mensaje = error.message.replace('ERROR_VALIDACION','').replace('ERROR: ', '');
            return Promise.reject(mensaje);
          }else{
            return Promise.reject('No fue posible recuperar la información.dfg');
          }
        }
      } else {
        return Promise.reject('Servicio no disponible por el momento.');
      }
    }
  }
  
